import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { reviews, aboutFeatures } from '@/mocks/manga';

function AboutSchemaOrg() {
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '古古漫画网',
        url: 'http://sylbdj.com/',
        description: '古古漫画网 - 提供终末的女武神等热门漫画在线免费阅读服务，简洁界面快速加载。',
        contactPoint: {
          '@type': 'ContactPoint',
          email: 'hello@sylbdj.com',
          contactType: 'customer service',
          availableLanguage: ['Chinese'],
        },
      },
      {
        '@type': 'WebPage',
        name: '关于我们 - 古古漫画网',
        url: 'http://sylbdj.com/about',
        description: '了解古古漫画网的品牌故事、用户口碑与联系方式。极速加载、海量漫画资源的在线免费阅读平台。',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'http://sylbdj.com/' },
            { '@type': 'ListItem', position: 2, name: '关于我们', item: 'http://sylbdj.com/about' },
          ],
        },
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export default function AboutPage() {
  return (
    <>
      <AboutSchemaOrg />
      <Navbar />

      <main>
        {/* About Hero */}
        <section className="bg-background-900 pt-24 pb-16 md:pt-28 md:pb-20" aria-label="关于古古漫画网">
          <div className="w-full px-4 md:px-6 text-center">
            <span className="whitespace-nowrap text-xs text-background-400/70 tracking-wider">
              关于古古
            </span>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mt-3 leading-tight">
              简洁界面
            </h1>
            <p className="font-heading text-2xl md:text-4xl text-background-50/60 mt-2">
              极速加载
            </p>
            <p className="font-heading text-xl md:text-3xl text-background-50/40 mt-1">
              陪伴追更
            </p>

            <div className="flex justify-center gap-3 mt-10">
              <Link
                to="/"
                className="whitespace-nowrap px-6 py-2.5 bg-background-50 text-foreground-900 text-sm font-medium rounded-md hover:bg-background-100 transition-colors cursor-pointer"
              >
                品牌故事
              </Link>
              <a
                href="mailto:hello@sylbdj.com"
                className="whitespace-nowrap px-6 py-2.5 border border-background-300/40 text-sm text-background-200 rounded-md hover:border-background-200 hover:text-background-50 transition-colors cursor-pointer"
              >
                商务合作
              </a>
            </div>

            <div className="flex flex-wrap gap-4 justify-center mt-16">
              {aboutFeatures.map((feature) => (
                <div
                  key={feature.id}
                  className="w-[160px] bg-background-800 rounded-lg p-5 text-center"
                >
                  <div className="w-8 h-8 mx-auto flex items-center justify-center">
                    <i className={`${feature.icon} text-xl text-background-200`} />
                  </div>
                  <p className="text-sm text-background-300 mt-3 font-medium">{feature.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Breadcrumb */}
        <div className="bg-background-100 border-b border-background-200/60">
          <div className="w-full px-4 md:px-6 py-3">
            <nav aria-label="面包屑导航" className="flex items-center gap-2 text-xs text-foreground-500">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <span>/</span>
              <span className="text-foreground-800">关于我们</span>
            </nav>
          </div>
        </div>

        {/* Brand Story */}
        <section className="bg-background-50 py-14 md:py-20" aria-label="品牌故事">
          <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8">
              品牌故事
            </h2>
            <div className="space-y-5 text-sm text-foreground-600 leading-relaxed">
              <p>
                <strong className="text-foreground-900">古古漫画网</strong>诞生于一群<strong>漫画爱好者</strong>的共同梦想。
                在经历了无数次在加载缓慢、广告弹窗不断的漫画网站上苦苦追更之后，我们决定自己打造一个真正属于读者的<strong>漫画阅读平台</strong>。
              </p>
              <p>
                我们的核心理念很简单：<strong>简洁、极速、纯粹</strong>。没有烦人的弹窗广告，没有复杂的操作流程，
                只有一个干净清爽的界面，让您能够专注于漫画本身，沉浸式地享受每一页精彩内容。
              </p>
              <p>
                从2024年上线至今，古古漫画网已经累计服务了超过百万漫画爱好者，站内收录了数千部热门漫画资源。
                我们始终坚持<strong>第一时间同步更新</strong>，确保读者不会错过任何一个精彩瞬间。
              </p>
              <p>
                我们深知，对于漫画迷来说，<strong>追更</strong>不仅仅是一种阅读行为，更是一种情感陪伴。
                每一周的等待，每一话的期待，都是生活中不可或缺的小确幸。古古漫画网，愿成为您追更路上最可靠的伙伴。
              </p>
              <p>
                未来，我们将持续优化产品体验，拓展更多优质漫画资源，让<strong>在线免费阅读漫画</strong>这件事，
                变得像翻开一本纸质漫画书一样自然、舒适。感谢每一位选择古古漫画网的读者，你们的支持是我们前进的最大动力。
              </p>
            </div>
          </div>
        </section>

        {/* Brand Reputation */}
        <section className="bg-background-50 py-10 md:py-14" aria-label="品牌声誉">
          <div className="w-full px-4 md:px-6">
            <div className="mb-10">
              <span className="whitespace-nowrap px-3 py-1 bg-accent-100 text-accent-700 text-xs rounded-full">
                品牌声誉
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-3">
                用户真实反馈
              </h2>
            </div>

            <div className="columns-1 sm:columns-2 lg:columns-3 gap-5">
              {reviews.map((review) => (
                <div
                  key={review.id}
                  className="break-inside-avoid mb-5 bg-background-50 border border-background-200 rounded-lg p-5 hover:border-background-300 transition-colors"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-secondary-200">
                      <img
                        src={review.avatar}
                        alt={review.name}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-800">{review.name}</p>
                      <p className="text-xs text-foreground-400">{review.username}</p>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 mt-4 leading-relaxed">
                    &ldquo;{review.comment}&rdquo;
                  </p>
                  <p className="text-xs text-foreground-400 mt-3">{review.date}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="bg-background-100 py-14 md:py-20" aria-label="联系我们">
          <div className="w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
            <span className="whitespace-nowrap px-3 py-1 bg-primary-100 text-primary-700 text-xs rounded-full">
              联系我们
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-3">
              期待与您交流
            </h2>
            <p className="text-sm text-foreground-500 mt-4 max-w-lg mx-auto">
              无论您是读者、作者还是合作伙伴，我们都非常欢迎您的来信。
              您的每一条反馈都是我们成长的养分。
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-10">
              <div className="bg-background-50 border border-background-200 rounded-lg p-6 text-center">
                <div className="w-10 h-10 mx-auto flex items-center justify-center">
                  <i className="ri-mail-line text-2xl text-primary-500" />
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mt-4">商务合作</h3>
                <p className="text-xs text-foreground-500 mt-2">hello@sylbdj.com</p>
              </div>
              <div className="bg-background-50 border border-background-200 rounded-lg p-6 text-center">
                <div className="w-10 h-10 mx-auto flex items-center justify-center">
                  <i className="ri-bug-line text-2xl text-accent-500" />
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mt-4">问题反馈</h3>
                <p className="text-xs text-foreground-500 mt-2">hello@sylbdj.com</p>
              </div>
              <div className="bg-background-50 border border-background-200 rounded-lg p-6 text-center">
                <div className="w-10 h-10 mx-auto flex items-center justify-center">
                  <i className="ri-chat-smile-2-line text-2xl text-secondary-500" />
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mt-4">读者交流</h3>
                <p className="text-xs text-foreground-500 mt-2">加入QQ群：123456789</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}